import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PayeeType.Save.IRequest;
type Response = Api.Core.PayeeType.Save.IResponse;
type Headers = Api.Core.PayeeType.Save.IHeaders;
const url = '/api/Claims/PayeeType';
export default async function payeeTypeSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
